/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ControlcenterMelcoModelsCreateCoupon,
    ControlcenterMelcoModelsCreateCouponFromJSON,
    ControlcenterMelcoModelsCreateCouponToJSON,
    ControlcenterMelcoModelsError,
    ControlcenterMelcoModelsErrorFromJSON,
    ControlcenterMelcoModelsErrorToJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsCoupon,
    ControlcenterMelcoModelsGenericList1MelcoModelsCouponFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsCouponToJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsCouponListItem,
    ControlcenterMelcoModelsGenericList1MelcoModelsCouponListItemFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsCouponListItemToJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory,
    ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistoryFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistoryToJSON,
} from '../models';

export interface CouponsApiCouponsCreateRequest {
    controlcenterMelcoModelsCreateCoupon?: ControlcenterMelcoModelsCreateCoupon;
}

export interface CouponsApiCouponsDeactivateRequest {
    id: string;
}

export interface CouponsApiCouponsDeleteRequest {
    id: string;
}

export interface CouponsApiCouponsEditRequest {
    id: string;
    controlcenterMelcoModelsCreateCoupon?: ControlcenterMelcoModelsCreateCoupon;
}

export interface CouponsApiCouponsHistoryRequest {
    id: string;
}

export interface CouponsApiCouponsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    productList?: string;
    codeList?: string;
    startDate?: Date;
    endDate?: Date;
    typeList?: string;
    usageTypeList?: string;
}

/**
 * 
 */
export class CouponsApi extends runtime.BaseAPI {

    /**
     */
    async couponsCreateRaw(requestParameters: CouponsApiCouponsCreateRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsCoupon>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/coupons`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoModelsCreateCouponToJSON(requestParameters.controlcenterMelcoModelsCreateCoupon),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsCouponFromJSON(jsonValue));
    }

    /**
     */
    async couponsCreate(requestParameters: CouponsApiCouponsCreateRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsCoupon> {
        const response = await this.couponsCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async couponsDeactivateRaw(requestParameters: CouponsApiCouponsDeactivateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling couponsDeactivate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/coupons/{Id}/deactivate`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async couponsDeactivate(requestParameters: CouponsApiCouponsDeactivateRequest): Promise<void> {
        await this.couponsDeactivateRaw(requestParameters);
    }

    /**
     */
    async couponsDeleteRaw(requestParameters: CouponsApiCouponsDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling couponsDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/coupons/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async couponsDelete(requestParameters: CouponsApiCouponsDeleteRequest): Promise<void> {
        await this.couponsDeleteRaw(requestParameters);
    }

    /**
     */
    async couponsEditRaw(requestParameters: CouponsApiCouponsEditRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsCoupon>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling couponsEdit.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/coupons/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoModelsCreateCouponToJSON(requestParameters.controlcenterMelcoModelsCreateCoupon),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsCouponFromJSON(jsonValue));
    }

    /**
     */
    async couponsEdit(requestParameters: CouponsApiCouponsEditRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsCoupon> {
        const response = await this.couponsEditRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async couponsHistoryRaw(requestParameters: CouponsApiCouponsHistoryRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling couponsHistory.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/coupons/{Id}/history`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistoryFromJSON(jsonValue));
    }

    /**
     */
    async couponsHistory(requestParameters: CouponsApiCouponsHistoryRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory> {
        const response = await this.couponsHistoryRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async couponsSearchRaw(requestParameters: CouponsApiCouponsSearchRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsCouponListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.productList !== undefined) {
            queryParameters['product_list'] = requestParameters.productList;
        }

        if (requestParameters.codeList !== undefined) {
            queryParameters['code_list'] = requestParameters.codeList;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.typeList !== undefined) {
            queryParameters['type_list'] = requestParameters.typeList;
        }

        if (requestParameters.usageTypeList !== undefined) {
            queryParameters['usage_type_list'] = requestParameters.usageTypeList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/coupons/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsCouponListItemFromJSON(jsonValue));
    }

    /**
     */
    async couponsSearch(requestParameters: CouponsApiCouponsSearchRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsCouponListItem> {
        const response = await this.couponsSearchRaw(requestParameters);
        return await response.value();
    }

}
